interface Props {
  /** Percent of target (may exceed 100). Null renders an empty, neutral bar. */
  pct: number | null;
  /** Threshold percentages to mark as ticks. */
  thresholds?: number[];
  className?: string;
}

/** Target progress: brand blue, orange from 90%, red past 100%. Threshold ticks sit on the track. */
export function ProgressBar({ pct, thresholds = [], className = '' }: Props) {
  const fill = pct === null ? 0 : Math.max(0, Math.min(100, pct));
  const color = pct === null ? '#cbd5e1' : pct >= 100 ? '#b91c1c' : pct >= 90 ? '#dd6e0c' : '#214592';
  return (
    <div className={`relative h-2.5 w-full rounded-full bg-slate-200 overflow-visible ${className}`} role="progressbar" aria-valuenow={pct ?? undefined} aria-valuemin={0} aria-valuemax={100}>
      <div className="h-2.5 rounded-full transition-all" style={{ width: `${fill}%`, background: color }} />
      {thresholds.filter(t => t > 0 && t <= 100).map(t => (
        <span
          key={t}
          title={`${t}% threshold`}
          className="absolute -top-0.5 h-3.5 w-0.5 bg-slate-500/70"
          style={{ left: `calc(${t}% - 1px)` }}
        />
      ))}
    </div>
  );
}
